import { create } from "zustand";
import { useFetchMonthlyVisitReportSlice } from "../slices/DailyVisitReportSlices/fetchMonthlyVisitReportSlice";
import { useFetchSummaryVisitReportSlice } from "../slices/DailyVisitReportSlices/fetchSummaryVisitReportSlice";
import { useFetchDayWiseVisitReportSlice } from "../slices/DailyVisitReportSlices/fetchDayWiseVisitReportSlice";

interface FetchDailyVisitReportInterface
  extends ReturnType<typeof useFetchMonthlyVisitReportSlice>,
    ReturnType<typeof useFetchSummaryVisitReportSlice>,
    ReturnType<typeof useFetchDayWiseVisitReportSlice> {}

export const FetchDailyVisitReportStore =
  create<FetchDailyVisitReportInterface>((...a) => ({
    ...useFetchMonthlyVisitReportSlice(...a),
    ...useFetchSummaryVisitReportSlice(...a),
    ...useFetchDayWiseVisitReportSlice(...a),
  }));
